export default "__VITE_ASSET__Zc7emU_S__"